import { LazyLoader } from '@bp/ui-components';
import { BpPage } from 'components/BpPage/BpPage';
import { useAuthClaims } from 'hooks/useAuthClaims';
import { usePermissionChecker } from 'hooks/usePermissionChecker';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import {
  DesktopNavigationTabs,
  type DesktopNavigationTabsType,
} from '../../components/NavigationTabs/Desktop/DesktopNavigationTabs';

export function MeetingsPage() {
  const { t } = useTranslation();
  const { pimAuthClaims } = useAuthClaims();
  const organization = pimAuthClaims.getOrganization();

  const permissions = usePermissionChecker();

  const tabs: DesktopNavigationTabsType[] = [
    {
      title: t('meetings.runningBBB'),
      path: `/meetings`,
      pathMatchEnd: true,
    },
    {
      title: t('meetings.runningZoom'),
      path: `/meetings/zoom`,
      disabled: true,
    },
  ];

  return (
    <BpPage
      title={t('meetings.title')}
      isForbidden={!permissions?.canViewMeetings(organization)}
      organization={pimAuthClaims.getOrganization()}
    >
      <DesktopNavigationTabs className='mb-6' tabs={tabs} />
      <Suspense fallback={<LazyLoader embedded transparent forceHeight='45vh' />}>{<Outlet />}</Suspense>
    </BpPage>
  );
}
